'use client';

import { DeviceContextProvider } from '~/context/common/DeviceContext';
import ExperimentProvider from '~/context/common/ExperimentProvider';
import { StaticContextProvider } from '~/context/common/StaticContext';
import { FinancingContextProvider } from '~/context/flp/FinancingContext';
import { GlobalContextProvider } from '~/context/flp/GlobalContext';
import { CriticalData } from '~/server-props/flp/getCriticalData';
import FinancingData from './FinancingData';
import FinancingProviders from './FinancingProviders';
import Marketing from './Marketing';
import Prequalified from './Prequalified';
import SoftpullModal from './SoftpullModal';
import ForAppWrapper from '../common/appRouter/ForAppWrapper';
import FeatureBranch from '../common/FeatureBranch/appRouter';

type OwnProps = CriticalData & {
  isLoggedIn: boolean;
  isNative: boolean;
};

export default function FinancingPage({
  forApp,
  forProviders,
  forServerUtils,
  isLoggedIn,
  isNative
}: OwnProps) {
  return (
    <ForAppWrapper appProps={forApp}>
      <FinancingProviders
        correlationId={forServerUtils.requestContext.correlationId}
      >
        <StaticContextProvider {...forProviders.forStaticContext}>
          <DeviceContextProvider {...forProviders.forDeviceContext}>
            <ExperimentProvider {...forProviders.forExperimentContext}>
              <GlobalContextProvider {...forProviders.forGlobalContext}>
                {!isNative && <FeatureBranch />}
                <FinancingContextProvider>
                  <FinancingData isLoggedIn={isLoggedIn} />
                  {isLoggedIn ? <Prequalified /> : <Marketing />}
                  <SoftpullModal />
                </FinancingContextProvider>
              </GlobalContextProvider>
            </ExperimentProvider>
          </DeviceContextProvider>
        </StaticContextProvider>
      </FinancingProviders>
    </ForAppWrapper>
  );
}
